// Import all of Bootstrap's JS
import * as bootstrap from "bootstrap";

(function ($, Drupal) {
  "use strict";

  /**
   * Behavior description.
   */
  Drupal.behaviors.hco150 = {
    attach: function (context, settings) {
      console.log("It works!");
      // const ex = new EX({ offset: 200 }).init();
    },
  };

  $(document).ready(function () {
    // const ex = new EX({ offset: 200 }).init();
    $(".colorado-header .navbar-toggler").click(function () {
      $(".colorado-header").toggleClass("open");
    });

    $(".colorado-header").hover(function () {
      $(this).toggleClass("hover");
    });

    $(".colorado-header ul li.dropdown .dropdown-menu li a").click(function () {
      $(".colorado-header").removeClass("open");
    });

    $(window).on("resize", function () {
      const win = $(this); //this = window
      if (win.width() <= 990) {
        $(".colorado-header").removeClass("hover");
        $(".colorado-header").removeClass("open");
      }
    });

    // Define the list of classes to check
    var classesToCheck = ["blue", "red", "light-blue"];
    // Select the div to check
    var divToCheck = $(
      ".node--type-colorado-150-page .hc-title-wrap:first-child"
    );

    // Find the matching class
    var matchingClass = $.grep(classesToCheck, function (className) {
      return divToCheck.hasClass(className);
    })[0];

    // If a matching class is found, assign it to another div
    if (matchingClass) {
      $(".utility-nav").addClass(matchingClass);
    }

    // Accessibility fixes starts
    //Script if header have class open then read navigation link
    $(".colorado-navbar .menu-hco-150 .menu-item a")
      .attr("tabindex", "-1")
      .attr("aria-hidden", "true");
    $(".colorado-header .navbar-toggler").click(function () {
      // Check if .colorado-header has the class 'open'
      if ($(".colorado-header").hasClass("open")) {
        // Remove tabindex and aria-hidden attributes when the class 'open' is present
        $(".colorado-navbar .menu-hco-150 .menu-item a")
          .removeAttr("tabindex")
          .removeAttr("aria-hidden");
      } else {
        // Add tabindex="-1" and aria-hidden="true" when the class 'open' is not present
        $(".colorado-navbar .menu-hco-150 .menu-item a")
          .attr("tabindex", "-1")
          .attr("aria-hidden", "true");
      }
    });

    // added aria-label attribute to the about us link
    $("a")
      .filter(function () {
        return $(this).text().toLowerCase() === "about us".toLowerCase();
      })
      .attr("aria-label", "About us");

    $("#cboxPrevious").attr("aria-label", "Previous Slide");
    $("#cboxNext").attr("aria-label", "Next Slide");
    $("#cboxSlideshow").attr("aria-label", "Toggle Slideshow");

    $('a[title="America 250 - Colorado 150 Connect with Us"]').removeAttr(
      "tabindex"
    );

    $("#goog-gt-votingForm #goog-gt-votingInputSrcLang").attr(
      "aria-label",
      "Source Language"
    );
    $("#goog-gt-votingForm #goog-gt-votingInputTrgLang").attr(
      "aria-label",
      "Target Language"
    );
    $("#goog-gt-votingForm #goog-gt-votingInputSrcText").attr(
      "aria-label",
      "Source Text"
    );
    $("#goog-gt-votingForm #goog-gt-votingInputTrgText").attr(
      "aria-label",
      "Translated Text"
    );
    $("#goog-gt-votingForm #goog-gt-votingInputVote").attr(
      "aria-label",
      "Vote"
    );
    $("hr").attr("aria-hidden", "true");



    setTimeout(function() {
      $('.panel-members-slide').each(function () {
        if ($(this).attr('aria-hidden') === 'true') {
          $(this).find('img').attr('tabindex', '-1');
          $(this).attr('tabindex', '-1');
        }
      });

      $('.slide-card').each(function() {
        if ($(this).attr('aria-hidden') === "true") {
          $(this).find('[tabindex="0"]').attr('tabindex', '-1');
        } else {
          $(this).find('[tabindex="-1"]').attr('tabindex', '0');
        }
      });
    }, 1000);

    $('.hero-wrap .hero-content').css('overflow', 'auto').attr('tabindex', '0');

    $('#resources h1').each(function () {
      // Check if the content is empty or contains only whitespace
      if ($(this).text().trim() === '') {
          $(this).html('<span class="visually-hidden">Placeholder text</span>');
      }
    })

    // Accessibility fixes end

    // Carousel for the homepage
    $(".connect-slider").slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow: false,
      nextArrow: false,
      autoplay: true,
      autoplaySpeed: 1000,
      infinite: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    });

    // Carousel for the panel members slider
    $(".panel-members-slider").slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: false,
      nextArrow: false,
      autoplay: true,
      autoplaySpeed: 1000,
      infinite: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    });

    // Check if an <h1> tag is not present
    if ($("h1").length === 0) {
      // Select the .navbar-brand element
      const $navbarBrand = $(".navbar-brand");
      if ($navbarBrand.length) {
        // Wrap the .navbar-brand in an <h1> tag
        $navbarBrand.wrap("<h1></h1>");

        // Add aria-label to the <a> element
        $navbarBrand.attr("aria-label", "Go to Colorado 150 homepage");
      }
    }

  });
  // Init animation library
  // new EX({
  //   watchClass: "ex-watch", // applies all js triggers on this class
  //   animateClass: "ex-animate", // css class which is added to start animation
  //   offset: 120, // distance to the element when triggering the animation
  //   mobile: true, // trigger animations on mobile devices
  //   live: true, // act on asynchronously loaded content
  //   callback: function (box) {
  //     // the callback is fired every time an animation is started
  //     // the argument that is passed in is the DOM node being animated
  //     // console.log(box);
  //   },
  //   scrollContainer: null, // optional scroll container selector, otherwise use window,
  //   resetAnimation: true, // reset animation on end
  // }).init();
})(jQuery, Drupal);
